import messages from '../stores/selected-store/messages';

export const fieldToErrorMap = {
  companyName: 'Invalid CompanyName',
  phone: 'Invalid Phone',
  email: 'Invalid Email',
};

export const errorToMessageMap = {
  [fieldToErrorMap.companyName]: messages.invalidCompanyNameError,
  [fieldToErrorMap.phone]: messages.invalidPhoneError,
  [fieldToErrorMap.email]: messages.invalidEmailError,
};
